import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import config from 'configs/app';
import SeoListPageShell from 'ui/shared/seo/SeoListPageShell';

const Tokens = dynamic(() => import('ui/pages/Tokens'), { ssr: false });

const Page: NextPage = () => {
  const title = config.meta.seo.enhancedDataEnabled ?
    `${ config.chain.name } tokens` :
    'Tokens';

  return (
    <SeoListPageShell pathname="/tokens" title={ title }>
      <Tokens hideTitle/>
    </SeoListPageShell>
  );
};

export default Page;
